module.exports = __webpack_public_path__ + "img/logo.b7c327c7.png";